import { Integration } from 'signup-constants/Integration';
export const isIntegrationValid = integration => {
  return Object.values(Integration).includes(integration);
};